import { Platform, StyleSheet } from 'react-native';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const styles = StyleSheet.create({
  disabledIcon: {
    opacity: 0.3,
  },
  enabledIcon: {
    opacity: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  bodyContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    backgroundColor: colors.white,
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  weiterContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  weiterStyle: {
    color: colors.primary,
  },
  responsiveText: {
    fontWeight: '700',
    color: colors.black,
  },
  scrollViewContentContainer: {
    paddingVertical: 30,
    paddingHorizontal: 40,
  },
  titleContainer: {
    justifyContent: 'center',
    marginBottom: 10,
  },
  titleText: {
    fontWeight: '700',
  },
  textContent: {
    fontWeight: '400',
    color: colors.black,
    lineHeight: IS_WEB ? 60 : 45,
    ...Platform.select({
      web: {
        userSelect: 'none',
        WebkitUserSelect: 'none',
      },
    }),
  },
});
